var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var PrintAPI = /** @class */ (function (_super) {
    __extends(PrintAPI, _super);
    function PrintAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrintAPI.prototype.print = function (props) { return this.fetcher.post("/api/print", props); };
    PrintAPI.prototype.getStatus = function (props) { return this.fetcher.get("/api/print/status", props); };
    PrintAPI.prototype.download = function (props) { window.open("/api/print/download?uuid=" + props.uuid, "_blank"); };
    return PrintAPI;
}(SubAPI));
export { PrintAPI };
